import {Injectable} from '@angular/core';
import {ErrorLogService} from '../modules/shared/service/error-log.service';
import {ApplicationError} from '../modules/shared/model/application-error';
import {noop, Subject} from 'rxjs';

@Injectable()
export class LoggerService {

  public error$: Subject<any> = new Subject<any>();

  constructor(private errorLogService: ErrorLogService) {}

  public httpRequestError(status: number, method: string, urlWithParams: string, httpResponseContent: string, showModal: boolean = true) {
    const error = new ApplicationError(`${status} | ${method} | ${urlWithParams}`, [{Args : 'ResponseContent: ' + httpResponseContent}], new Date());
    console.error(error.message);
    this.errorLogService.sendError(error);
    showModal ? this.error$.next(null) : noop();
  }

  public clientError(errorName: string, route: string, message: string, stackTrace: any[]) {
    const error = new ApplicationError(`${errorName} | ${route} | ${message}`, stackTrace, new Date());
    this.errorLogService.sendError(error);
  }
}
